import { lazy } from 'react';

// eslint-disable-next-line import/no-cycle
export const loadAuthDialog = () => import('@glass/shared/components/Auth/AuthDialog');

const LazyAuthDialog = lazy(loadAuthDialog);

export default LazyAuthDialog;
